import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as AgentsIcon } from "../../../../../assets/images/People/Teams/agents.svg";
import { ReactComponent as TotalChatsIcon } from "../../../../../assets/images/People/Teams/total-chats.svg";
import { ReactComponent as TotalTicketsIcon } from "../../../../../assets/images/People/Teams/total-tickets.svg";

const containerSx = {
  width: "100%",
  maxWidth: 632,
  height: 96,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  display: "flex",
  boxSizing: "border-box",
  mb: 3,
};

function StatCell({ icon: Icon, label, value, showDivider }) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        px: 3,
        boxSizing: "border-box",
        borderRight: showDivider ? "1px solid #E5E9EC" : "none",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.75 }}>
        <Icon style={{ width: 16, height: 16, flexShrink: 0 }} />
        <Typography
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 24,
          fontWeight: 500,
          lineHeight: "34px",
        }}
      >
        {value.toLocaleString()}
      </Typography>
    </Box>
  );
}

export default function TeamDetailStatsRow({ stats }) {
  return (
    <Box sx={containerSx}>
      <StatCell icon={AgentsIcon} label="Agents" value={stats.agents} showDivider />
      <StatCell icon={TotalChatsIcon} label="Total Chats" value={stats.totalChats} showDivider />
      <StatCell
        icon={TotalTicketsIcon}
        label="Total Tickets"
        value={stats.totalTickets}
        showDivider={false}
      />
    </Box>
  );
}
